// 联系电话验证
export function userFall(str) {
  const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
  return reg.test(str);
}
